/**
 * It must contain at least one lowercase letter (a-z).
 * It must contain at least one uppercase letter (A-Z).
 * It must contain at least one digit (0-9).
 * It must be at least 8 characters in length.
 */
export const passwordValidationRegex =
    /^(?=.*[a-zåäöøæ])(?=.*[A-ZÅÄÖÆØ])(?=.*[0-9]).{8,}$/;
export const passwordRules =
    'required: lower; required: digit; required: upper;';
export const passwordMinLength = 8;
